import React from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";

export default function EmergencyAlertBanner({ count = 0, onScrollToUrgent }) {
  if (!count || count <= 0) return null;

  return (
    <div className="mb-5 bg-white/95 backdrop-blur-md rounded-lg p-3.5 sm:px-5 sm:py-3.5 border border-rose-200/90 shadow-sm shadow-rose-500/5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 transition-all hover:shadow-md hover:shadow-rose-500/10 animate-in fade-in duration-300">
      <div className="flex items-center gap-3.5 min-w-0">
        {/* Ô icon vuông giữ nguyên kích thước chuẩn w-10 h-10 */}
        <div className="w-10 h-10 rounded-md bg-gradient-to-br from-rose-500 to-red-600 text-white shadow-md shadow-rose-500/25 flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-white animate-pulse" />
        </div>

        {/* Khối 2 dòng chữ căn giữa cân xứng tuyệt đối */}
        <div className="min-w-0 flex-1 flex flex-col justify-center translate-y-[6px]">
          {/* Dòng 1: Badge và Tiêu đề */}
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-rose-50 text-rose-700 border border-rose-200 text-[11px] font-bold leading-none tracking-tight flex-shrink-0">
              <span className="w-2 h-2 rounded-full bg-rose-500 animate-ping inline-block" />
              Cảnh báo khẩn cấp
            </span>
            <h4 className="text-sm sm:text-[15px] font-bold text-slate-900 tracking-tight leading-none translate-y-[3px]">
              Phát hiện <span className="text-rose-600 font-extrabold">{count}</span> phản ánh yêu cầu xử lý ngay
            </h4>
          </div>

          {/* Dòng 2: Nội dung mô tả */}
          <p className="text-xs text-slate-500 leading-snug">
            Các hồ sơ này có mức độ ưu tiên cao nhất, đề nghị cán bộ phụ trách khẩn trương điều phối và giải quyết kịp thời.
          </p>
        </div>
      </div>

      {/* Nút hành động */}
      {onScrollToUrgent && (
        <button
          type="button"
          onClick={onScrollToUrgent}
          className="inline-flex items-center justify-center gap-1.5 px-3.5 py-2 bg-gradient-to-r from-rose-600 to-red-600 hover:from-rose-700 hover:to-red-700 active:scale-95 text-white text-xs font-semibold rounded-md shadow-sm shadow-rose-500/20 hover:shadow-md hover:shadow-rose-500/30 transition-all whitespace-nowrap self-start sm:self-center cursor-pointer flex-shrink-0"
        >
          <span>Xem danh sách khẩn</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
